import { LoginFormView } from './login-form.view';

export const LoginForm = LoginFormView;
